import { FC, useState, useEffect, ReactNode } from 'react';
import { ProCheckbox } from '../antd';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { CheckboxGroupProps } from 'antd/lib/checkbox';
import { useLayoutContext } from '../PageLayout/context/LayoutContext';
import { renderEnumNames, renderEnumName } from '../utils/renderUtils';
import { TABLE_COLUMN_EMPTY } from '../constants/constant';

export interface SearchFormCheckboxGroupProps extends BaseSearchFormItemProps {
  /** checkboxGroup Props */
  checkboxGroupProps?: CheckboxGroupProps;
  /** 枚举名称 */
  enumCode?: string;
}
/** 多选框 */
export const SearchFormCheckboxGroup: FC<SearchFormCheckboxGroupProps> = props => {
  const {
    checkboxGroupProps,
    isDetail,
    form,
    enumCode,
    isTable,
    name,
    testId,
    hideLabel,
    label,
    render,
    disabledRender,
    ...resProps
  } = props;
  const [options, setOptions] = useState<any[]>(
    checkboxGroupProps?.options || [],
  );
  const { enumData } = useLayoutContext();
  
  useEffect(() => {
    if (checkboxGroupProps?.options) {
      setOptions(checkboxGroupProps?.options);
      return;
    }
    if (enumCode && enumData) {
      setOptions(enumData[enumCode] ? enumData[enumCode].items || [] : []);
    }
  }, [enumCode, checkboxGroupProps?.options]);
  const renderText = (): ReactNode => {
    const groupVal = form?.getFieldValue?.(name as string) || checkboxGroupProps?.value;
    if (!groupVal || !options.length) return TABLE_COLUMN_EMPTY;
    if (Array.isArray(groupVal)) {
      return renderEnumNames(groupVal, options, '，');
    }
    return groupVal ? renderEnumName(groupVal, options) : TABLE_COLUMN_EMPTY;
  };
  return (
    <SearchFormItem {...resProps} name={name} label={!hideLabel && label}>
      {isDetail || (checkboxGroupProps && checkboxGroupProps.disabled) ? (
        <SearchFormDisabled form={form} render={render || disabledRender || renderText} isTable={isTable} />
      ) : (
        <ProCheckbox.Group
          options={options}
          {...checkboxGroupProps}
          test-id={`${testId}-${name}`}
        />
      )}
    </SearchFormItem>
  );
};

SearchFormCheckboxGroup.displayName =
  SearchFormItemEnum.SearchFormCheckboxGroup;

export default SearchFormCheckboxGroup;
